import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ADDITIONAL_PROPERTY_FLAG, TranslatableString } from '@rjsf/utils';
import Label from "./FieldTemplate/Label";
/** The `WrapIfAdditional` component is used by the `FieldTemplate` to rename, or remove properties that are
 * part of an `additionalProperties` part of a schema.
 *
 * @param props - The `WrapIfAdditionalProps` for this component
 */

export default function WrapIfAdditionalTemplate(props) {
  var id = props.id,
      classNames = props.classNames,
      style = props.style,
      disabled = props.disabled,
      label = props.label,
      onKeyChange = props.onKeyChange,
      onDropPropertyClick = props.onDropPropertyClick,
      readonly = props.readonly,
      required = props.required,
      schema = props.schema,
      children = props.children,
      uiSchema = props.uiSchema,
      registry = props.registry;
  var templates = registry.templates,
      translateString = registry.translateString; // Button templates are not overridden in the uiSchema

  var RemoveButton = templates.ButtonTemplates.RemoveButton;
  var keyLabel = translateString(TranslatableString.KeyLabel, [label]);
  var additional = (ADDITIONAL_PROPERTY_FLAG in schema);

  if (!additional) {
    return _jsx("div", {
      className: classNames,
      style: style,
      children: children
    });
  }

  return _jsx("div", {
    className: classNames,
    style: style,
    children: _jsxs("div", {
      className: 'row',
      children: [_jsx("div", {
        className: 'col-xs-5 form-additional',
        children: _jsxs("div", {
          className: 'form-group',
          children: [_jsx(Label, {
            label: keyLabel,
            required: required,
            id: "".concat(id, "-key")
          }), _jsx("input", {
            className: 'form-control',
            type: 'text',
            id: "".concat(id, "-key"),
            onBlur: function onBlur(_ref) {
              var target = _ref.target;
              return onKeyChange(target && target.value);
            },
            defaultValue: label
          })]
        })
      }), _jsx("div", {
        className: 'form-additional form-group col-xs-5',
        children: children
      }), _jsx("div", {
        className: 'col-xs-2',
        children: _jsx(RemoveButton, {
          className: 'array-item-remove btn-block',
          style: {
            border: '0'
          },
          disabled: disabled || readonly,
          onClick: onDropPropertyClick(label),
          uiSchema: uiSchema,
          registry: registry
        })
      })]
    })
  });
}